export const ActionTypes = {
  HANDLE_HTTP_ERROR: 'harami/interceptions/HANDLE_HTTP_ERROR',
} as const
